import React, {Component} from 'react';
import {connect} from "~/redux/connect";
import {getSearchModel, getSearchTerm} from "~/stateGetter";
import Pagination from './SearchResultPagination';
import ResultTable from "./SearchResultTable";
import NavigatableTableBlueprint from "~/ui/components/ResultTable/NavigatableResultTable";
import getLoadingState from "~/conclude/loading";
import { compareKeys, diffKeys } from 'mythil/object';

const _NavigatableResultTable = NavigatableTableBlueprint({Pagination,ResultTable});

const NavigatableModelTable = connect((state, {modelName, filterResultsValue}) => {
    let searchModel = getSearchModel(state, modelName),
        resultValue = searchModel.results.value,
        perPage = searchModel.resultParams.perPage;

    resultValue = filterResultsValue ? filterResultsValue(resultValue) : resultValue;

    return {
        searchFilterValue: getSearchTerm(state),
        resultValue,
        perPage,
    }
}, () => {
    return {

    };
}, ({ ...props}, dispatchers, {modelName, ...ownProps}) => {
    return {
        ...props,
        ...ownProps,
        ...dispatchers,
        loading: false,
        canSort: false,
        canResize: false,
        commonProps: { modelName }
    }
}, {
    areStatePropsEqual: (prev, curr) => {
        return compareKeys(prev, curr, (prev, curr, prop) => {
            switch (prop) {
                case "searchFilterValue": {
                    return true;
                }
                default: {
                    return prev === curr
                }
            }
        })
    }
})(_NavigatableResultTable);


export default NavigatableModelTable;